import React from 'react';

export default function HiddenSubmitButton() {
  return <input type="submit" style={{display: 'none'}} />;
}



// WEBPACK FOOTER //
// ./app/features/shared/components/HiddenSubmitButton.js